import { createRoot } from 'react-dom/client';
import * as vp from 'vopay';
import { StrictMode } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { MainProvider } from '@/providers/Main.provider';

import App from '@/App';
import SessionManager from '@/components/Logging/SessionManager';
import PageNavLogger from '@/components/Logging/PageNavLogger';
import NativeButtonLogger from '@/components/Logging/NativeButtonLogger';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router getUserConfirmation={vp.UserNavPrompt}>
      <MainProvider>
        <SessionManager>
          <PageNavLogger>
            <NativeButtonLogger>
              <App />
            </NativeButtonLogger>
          </PageNavLogger>
        </SessionManager>
      </MainProvider>
    </Router>
  </StrictMode>,
);
